'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { CatalogRequestParams, ValueFacet } from '@/src/lib/category/types.ts';
import { usePathname, useRouter } from 'next/navigation';
import Select from '@/src/app/components/Select/Select.tsx';
import { SelectOption } from '@/src/types/select-option.ts';
import FilterChipBar from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/FilterChipBar.tsx';
import { buildValueFacetChips } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/lib/business/category-page-filters.ts';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
export type ValueFilterProps = {
  facet: ValueFacet;
  showChips?: boolean;
  className?: string;
};
export default function ValueFilter(t0) {
  const $ = _c(26);
  const {
    facet,
    showChips,
    className
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  const {
    startTransition,
    isPending
  } = useContext(LayoutTemplateContext);
  let t1;
  if ($[0] !== facet.values) {
    t1 = facet.values.map(_temp);
    $[0] = facet.values;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== facet || $[3] !== showChips) {
    t2 = showChips ? buildValueFacetChips(facet) : [];
    $[2] = facet;
    $[3] = showChips;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const chips = t2;
  let t3;
  if ($[5] !== facet.name || $[6] !== pathname || $[7] !== router || $[8] !== startTransition) {
    t3 = options_0 => {
      startTransition(async () => {
        const currentSearchParams = new URLSearchParams(window.location.search);
        if (Array.isArray(options_0)) {
          const multiFacetName = `${facet.name}[]`;
          currentSearchParams.delete(multiFacetName);
          options_0.forEach(option => {
            currentSearchParams.append(multiFacetName, option.value as string);
          });
        } else {
          const currentValue = `${(options_0 as SelectOption).value}`;
          if (!currentValue) {
            currentSearchParams.delete(facet.name);
          } else {
            currentSearchParams.set(facet.name, currentValue);
          }
        }
        currentSearchParams.set(CatalogRequestParams.PAGE, "1");
        router.push(decodeURI(`${pathname}?${currentSearchParams.toString()}`));
      });
    };
    $[5] = facet.name;
    $[6] = pathname;
    $[7] = router;
    $[8] = startTransition;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onChange = t3;
  const t4 = `filter-${facet.name}`;
  const t5 = facet.activeValue ?? undefined;
  const t6 = isPending || facet.isDisabled;
  let t7;
  if ($[10] !== facet.config.isMultiValued || $[11] !== facet.localizedName || $[12] !== facet.name || $[13] !== onChange || $[14] !== options || $[15] !== t5 || $[16] !== t6) {
    t7 = <Select value={t5} options={options} placeholder={facet.localizedName} disabled={t6} onSelectionChangeHook={onChange} isMultiple={facet.config.isMultiValued} name={facet.name} />;
    $[10] = facet.config.isMultiValued;
    $[11] = facet.localizedName;
    $[12] = facet.name;
    $[13] = onChange;
    $[14] = options;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== chips || $[19] !== showChips) {
    t8 = chips.length && showChips ? <FilterChipBar chips={chips} className="mt-2" /> : null;
    $[18] = chips;
    $[19] = showChips;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== className || $[22] !== t4 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={className} data-testid={t4}>{t7}{t8}</div>;
    $[21] = className;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(t0) {
  const {
    value
  } = t0;
  return {
    label: value.toString(),
    value
  };
}